module.exports = __webpack_public_path__ + "img/icon_line_tab4.8fc916db.png";